import { render, staticRenderFns } from "./logz.vue?vue&type=template&id=09526fd8&"
import script from "./logz.vue?vue&type=script&lang=js&"
export * from "./logz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports